function e(a) {
  return { name: "Node REPL", contains: [{ className: "meta.prompt", starts: { end: / |$/, starts: { end: "$", subLanguage: "javascript" } }, variants: [{ begin: /^>(?=[ ]|$)/ }, { begin: /^\.\.\.(?=[ ]|$)/ }] }] };
}
export {
  e as default
};
